import {
  Box,
  Text,
  Grid,
  GridItem,
  VStack,
  AspectRatio
} from '@chakra-ui/react'
import Image from 'next/image'

const KeyIngredientItem = ({ title, src }: { title: string; src: any }) => {
  return (
    <GridItem
      colSpan={{
        base: 6,
        md: 4
      }}
    >
      <VStack alignItems="center">
        <AspectRatio w={140} ratio={1 / 1} position="relative">
          <Image
            src={src}
            alt={title || ''}
            fill
            style={{
              border: '4px solid #E7CD7E',
              borderRadius: '50%'
            }}
          />
        </AspectRatio>

        <Text textStyle="docKeyIngredient" textAlign="center" mt={4} w={160}>
          {title}
        </Text>
      </VStack>
    </GridItem>
  )
}

const KeyIngredient = () => {
  return (
    <Box my={20} py={10}>
      <Text
        textTransform="uppercase"
        textStyle="docMainTitle"
        textAlign="center"
      >
        KEY INGREDIENTS
      </Text>

      <Grid
        templateColumns="repeat(12, 1fr)"
        pt={10}
        gap={{
          md: 12,
          base: 4
        }}
      >
        <KeyIngredientItem
          src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/hyaluronic-acid-1710999768989.png"
          title="Hyaluronic Acid"
        />
        <KeyIngredientItem
          src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/camellia-oil-1710999768991.png"
          title="Camellia Oil"
        />
        <KeyIngredientItem
          src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/royal-jelly-extract-1710999768992.png"
          title="Royal Jelly Extract"
        />
        <KeyIngredientItem
          src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/vitamin-e-1710999768992.png"
          title="Vitamin E"
        />
        <KeyIngredientItem
          src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/filtrate-1710999768993.png"
          title="Galactomyces Fermentation Filtrate"
        />
        <KeyIngredientItem
          src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/niacinamide-1710999768993.png"
          title="Niacinamide"
        />
        <KeyIngredientItem
          src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/propolis-extract-1710999768994.png"
          title="Propolis Extract"
        />
        <KeyIngredientItem
          src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/aloe-vera-1710999768994.png"
          title="Aloe Vera"
        />
        <KeyIngredientItem
          src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/green-tea-extract-1710999768995.png"
          title="Green Tea Extract"
        />
        <KeyIngredientItem
          src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/po-extract-1711000118695.png"
          title="Propolis Extract"
        />
        <KeyIngredientItem
          src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/growth-factor-1711000118694.png"
          title="Epidermal Growth Factor"
        />
        <KeyIngredientItem
          src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/three-ade-1711000118693.png"
          title="3 Adenosine"
        />
        <KeyIngredientItem
          src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/ceramide-np-1710999768996.png"
          title="Ceramide NP"
        />
        <GridItem
          colSpan={{
            base: 12,
            md: 8
          }}
          mt={{
            base: 10,
            md: 0
          }}
        >
          <Text
            textTransform="uppercase"
            textStyle="docKeyIngredientTitle"
            textAlign="left"
          >
            POTENT INGREDIENTS
          </Text>
          <Text textStyle="docInfo" lineHeight="20px" textAlign="left">
            Full of nourishing active ingredients such as Hyaluronic acid,
            niacinamide, vitamin E, green tea extract, and epidermal growth
            factor (EGF) to moisturize, calm, and reduce the look of age on the
            skin.
          </Text>
          <Text textStyle="docKeyIngredientTitle" mt={4} textAlign="left">
            Product Specifications
          </Text>
          <Text textStyle="docInfo" lineHeight="20px" textAlign="left">
            Made in Korea <br /> Capacity: 110ml
          </Text>
        </GridItem>
      </Grid>
    </Box>
  )
}

export default KeyIngredient
